<script>
import { mapActions } from 'vuex';

export default {
  page: {
    title: 'logout',
    meta: [{ name: 'description', content: 'logout' }],
  },
  mounted() {
    this.updateIsChain(null);
    this.updateOrderAcceptingStatus(null);
    this.$sendEvent('RS_Logout');
    this.logOut()
      .then(() => {
        this.$router.replace({ name: 'login' });
      });
  },
  methods: {
    ...mapActions({
      logOut: 'auth/logOut',
      updateIsChain: 'app/updateIsChain',
      updateOrderAcceptingStatus: 'app/updateOrderAcceptingStatus',
    }),
  },
};
</script>

<template>
  <h1 :class="$style.title">
    logout... <i class="fa fa-refresh fa-spin" />
  </h1>
</template>

<style lang="scss" module>
.title {
  text-align: center;
  margin-top: 10%;
}
</style>
